import { render } from "./ModelSelect.vue?vue&type=template&id=5120c1e3&scoped=true"
import script from "./ModelSelect.vue?vue&type=script&lang=js"
export * from "./ModelSelect.vue?vue&type=script&lang=js"

import "./ModelSelect.vue?vue&type=style&index=0&id=5120c1e3&scoped=true&lang=css"
import "./ModelSelect.vue?vue&type=style&index=1&id=5120c1e3&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5120c1e3"]])

export default __exports__